import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, mapCourierError, updateCourier, useTranslation } from '@dukanti/shared';
import type { Courier, CourierUpdateInput, TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useUpdateCourier(
  storeId: string,
): UseMutationResult<Courier, unknown, CourierUpdateInput> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<Courier, unknown, CourierUpdateInput>({
    mutationFn: (input) => updateCourier(supabase, input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.list(storeId) });
      toast.success(t('admin.couriers.toasts.updated' as TranslationKey));
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
